<template>
	<section>
		<div v-if="news.list == false"></div>
		<div v-else class="iv2-section-news theme-c__home-news-bg">
			<div class="iv2-top-news__content container">
				<div class="row clearfix" draggable="false">
					<div class="column full text-center">
						<p class="m-0">{{ subtitle }}</p>
						<h3 class="theme__heading-text">{{ title }}</h3>
					</div>
				</div>
				<div class="row clearfix">
					<div class="column full">
						<div class="spacer height-40"></div>
					</div>
				</div>
				<div v-if="news.list" class="row clearfix">
					<div
						v-for="item in limitCount"
						:key="item.id"
						class="iv2-top-news-item mb-5 col-md-6 col-xl-4"
					>
						<router-link :to="'/news/' + item.id" class="iv2-top-news-item__link">
							<div class="iv2-top-news-item__img fit-img">
								<img :src="item.thumbnail" class="m-0" alt />
							</div>

							<div class="iv2-top-news-item__data mt-4">
								<div class="row">
									<div class="col-6 pr-0">
										<small class="iv2-top-news-item__date">
											{{
											item.created | moment
											}}
										</small>
										<small
											v-if="isAfter(setDatetime(item.created), end)"
											class="iv2-top-news-item__new ml-1"
										>{{ new_label }}</small>
									</div>
									<div class="col-6" style="padding-top: 3px;">
										<small class="iv2-top-news-item__label d-block">
											{{
											item.category_name
											}}
										</small>
									</div>
								</div>
							</div>
							<h3 class="iv2-top-news-item__title">{{ item.title }}</h3>
						</router-link>
					</div>
				</div>
				<div v-if="rss.outbound" class="row clearfix">
					<div class="column full" style="margin: 0 auto;">
						<div style="text-align: center;">
							<span>
								<router-link
									to="/news"
									class="theme__main-btn is-btn is-btn-ghost2 is-upper"
									style="border: 0; letter-spacing: 2px; max-width: 100%; width: 300px; padding-top: 15px; padding-bottom: 15px; margin: 5px;"
								>{{ news_btn_text }}</router-link>
								<a
									v-if="rss.outbound.status == 1"
									:href="rss.outbound.href"
									target="_brank"
									rel="noopener"
									class="theme__main-btn is-btn is-btn-ghost2 is-upper"
									style="border: 0; letter-spacing: 2px; max-width: 100%; width: 300px; padding-top: 15px; padding-bottom: 15px; margin: 5px;"
								>
									<i class="fas fa-rss"></i>
									{{ rss_btn_text }}
								</a>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import moment from "moment";

export default {
	data() {
		return {
			news: [],
			rss: [],

			title: "NEWS",
			subtitle: "お知らせ",
			new_label: "NEW",
			news_btn_text: "お知らせ一覧",
			rss_btn_text: "RSSフィード",

			limit: 3,
			start: "",
			end: moment().format()
		};
	},

	created() {
		this.axios.get("/json/news_list.json").then(response => {
			this.news = response.data.news;
		});

		this.axios.get("/json/rss.json").then(response => {
			this.rss = response.data.rss;
		});
	},

	methods: {
		isAfter: function(start, end) {
			return moment(start).isAfter(end);
		},

		setDatetime: function(start) {
			return moment(start)
				.add(14, "days")
				.format();
		}
	},

	computed: {
		limitCount() {
			return this.news.list.slice(0, this.limit);
		}
	},

	filters: {
		moment: function(created) {
			return moment(created).format("YYYY年MM月DD日");
		}
	}
};
</script>

<style lang="scss">
.iv2-section-news {
	padding-bottom: 100px;
	margin-bottom: -160px;
	margin-top: 80px;

	.iv2-top-news__content {
		padding-top: 100px;
	}
}

.iv2-top-news-item .iv2-top-news-item__link {
	display: block;
	text-decoration: none;

	&:hover .iv2-top-news-item__img {
		opacity: 0.7;
	}

	.iv2-top-news-item__img {
		height: 200px;
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	.iv2-top-news-item__title {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.iv2-top-news-item__new {
		color: #ff0a0a;
		border: 1px solid;
		padding: 6px 10px;
	}

	.iv2-top-news-item__label {
		width: 100%;
		text-align: center;
		border: 1px solid;
	}
}

@media (max-width: 1199px) {
	.iv2-section-news {
		margin-bottom: -80px;
	}
	.iv2-top-news-item {
		.iv2-top-news-item__link {
			.iv2-top-news-item__title {
				font-size: 1.1rem;
			}
		}
	}
}
</style>
